import { ThemedButton } from "Components/Themes/components/ThemedButton";
import styled from "styled-components";

export const RetryPriceCheckButton = styled(ThemedButton)`
  margin-top: 8px;
  width: fit-content;
`;
